import { useState } from 'react';

import { PlaceholderCard, Popover } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import CreateUserRole from './CreateUserRole';
import CreateGroupRole from './CreateGroupRole';

export default function RolePlaceholder(props: {
	user: graphql.User;
	type: 'user' | 'group';
	inverse?: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	refetch: () => Promise<any>;
}) {
	const [visible, setVisible] = useState(false);

	return (
		<Popover.Target
			visible={visible}
			contents={
				props.type === 'user' ? (
					<CreateUserRole
						user={props.user}
						inverse={props.inverse}
						refetch={props.refetch}
						onCancel={() => setVisible(false)}
						onCreate={() => setVisible(false)}
					/>
				) : (
					<CreateGroupRole
						user={props.user}
						refetch={props.refetch}
						onCancel={() => setVisible(false)}
						onCreate={() => setVisible(false)}
					/>
				)
			}
			onDismiss={() => setVisible(false)}
		>
			<PlaceholderCard height={48} onClick={() => setVisible(true)} />
		</Popover.Target>
	);
}
